$(function(){

  var ua = window.navigator.userAgent.toLowerCase();
  var $body = $('body');

  // ブラウザ判定
  if (ua.includes("edge") || ua.includes("edga") || ua.includes("edgios")) {
    $body.addClass('edge');
  } else if (ua.includes("opera") || ua.includes("opr")) {
    $body.addClass('opera');
  } else if (ua.includes("samsungbrowser")) {
    $body.addClass('sib');
  } else if (ua.includes("ucbrowser")) {
    $body.addClass('ucb');
  } else if (ua.includes("chrome") || ua.includes("crios")) {
    $body.addClass('chrome');
  } else if (ua.includes("firefox") || ua.includes("fxios")) {
    $body.addClass('firefox');
  } else if (ua.includes("safari")) {
    $body.addClass('safari');
  } else if (ua.includes("msie") || ua.includes("trident")) {
    $body.addClass('ie');
  } else {
    $body.addClass('unknown');
  }

  // OS判定
  if (ua.includes("windows nt")) {
    $body.addClass('win');
  } else if (ua.includes("android")) {
    $body.addClass('android');
  } else if (ua.includes("iphone") || ua.includes("ipad")) {
    $body.addClass('ios');
  } else if (ua.includes("mac os x")) {
    $body.addClass('mac');
  } else {
    $body.addClass('unknown-os');
  }
  

  /* -------------------------------------------------------------------
	slick
	------------------------------------------------------------------- */

  var sliderCount = $('.c-slide').length;
  var initCount = 0;
  
  $('.c-slide').each(function (index, element) {
    var $slider = $(element);
  
    $slider.on('init', function (event, slick) {
      initCount++;
  
      // すべてのスライダーが初期化されたら1回だけScrollTrigger.refresh()
      if (initCount === sliderCount) {
        setTimeout(function() {
          ScrollTrigger.refresh();
        }, 3000);
      }
    });
  
    $slider.slick({
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 2000,
      dots: true,
      arrows: false,
    });
  });
  

  // テキスト分割
  $('.c-fix__subtitle--sm').each(function() {
    var text = $(this).text(); // テキストを取得
    var chars = text.split(''); // 文字単位で分割
  
    var delayCount = 0; // delay用のカウント変数
  
    // 分割された文字を新しい HTML に置き換え
    var newHtml = chars.map(function(char) {
      // スペースは無視する
      if (char === ' ') {
        return char; // スペースはそのまま返す
      }
  
      // delayCountを使用して、スペースを無視してdelayを増加
      var delayValue = ` delaymin="${delayCount * 1}"`; // 最初は0, 以降2ずつ増加
      delayCount++; // delayCountを進める
  
      return `<span class="u-split"${delayValue}>${char}</span>`;
    }).join(''); // 空白なしで結合
  
    // 新しいHTMLをセット
    $(this).html(newHtml);
  });

  $('.page-top').click(function () {
      $('body,html').animate({
      scrollTop: 0
      }, 400);
      return false;
  });
    
});//function

$(window).on("load", function() {
  setTimeout(function() {
    $("body").addClass("loaded");
  }, 1000);
  setTimeout(function() {
    $("body").addClass("ophide").trigger("ophideComplete").removeClass("hidden");
  }, 2500);
  setTimeout(function() {
    $("body").addClass("opbghide");
  }, 2800);
  setTimeout(function() {
    $(".c-header__img").addClass("active");
  }, 3500);

  setTimeout(function() {
    $(".c-fix__title").addClass("active");
  }, 5000);
  setTimeout(function() {
    $(".c-fix__subtitle--wrap").addClass("active");
  }, 5500);

  // setTimeout(function() {
  //   ScrollTrigger.refresh();
  // }, 6000);
  
  var counter = 0;
  var counter2 = 0;

  function toggleClasses() {
    var delay = (counter === 0) ? 6500 : 0;

    setTimeout(function() {
      $('.slide-txt1').addClass('start');
    }, delay);

    setTimeout(function() {
      $('.slide-txt1').addClass('hide');
    }, delay + 3500);

    setTimeout(function() {
      $('.slide-txt1').removeClass('start hide');
    }, delay + 4500);

    setTimeout(function() {
      counter++;
      toggleClasses();
    }, delay + 5000); // 繰り返し
  }

  function toggleClasses2() {
    var delay = (counter2 === 0) ? 7000 : 500;

    setTimeout(function() {
      $('.slide-txt2').addClass('start');
    }, delay);

    setTimeout(function() {
      $('.slide-txt2').addClass('hide');
    }, delay + 3500);

    setTimeout(function() {
      $('.slide-txt2').removeClass('start hide');
    }, delay + 4500);

    setTimeout(function() {
      counter2++;
      toggleClasses2();
    }, delay + 4500); // 繰り返し

  }

  // 初回の実行
  toggleClasses();
  toggleClasses2();

});


gsap.registerPlugin(ScrollTrigger);

// 初期状態を透明にする
gsap.set(".c-cover__img--parrent01", { autoAlpha: 0 });

// 【既存の ScrollTrigger】（ピン留めの設定）
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent01",
  start: "top 80", // ピン留めの開始位置
  endTrigger: ".c-cover__img--child01",
  end: "top+=-280px",
  pin: true,
  pinSpacing: false,
  // markers: true,
});

// 【フェードイン用の ScrollTrigger】
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent01",
  start: "top+=100px bottom",
  once: true,
  onEnter: () => {
    gsap.fromTo(".c-cover__img--parrent01", 
      { autoAlpha: 0, y: 30 }, 
      { autoAlpha: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  },
  invalidateOnRefresh: true,
});



// 初期状態を透明にする
gsap.set(".c-cover__img--parrent02", { autoAlpha: 0 });

// 【既存の ScrollTrigger】（ピン留めの設定）
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent02",
  start: "top 80", // ピン留めの開始位置
  endTrigger: ".c-cover__img--child02",
  end: "top+=-280px",
  pin: true,
  pinSpacing: false,
  // markers: true,
});

// 【フェードイン用の ScrollTrigger】
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent02",
  start: "top+=100px bottom",
  once: true,
  onEnter: () => {
    gsap.fromTo(".c-cover__img--parrent02", 
      { autoAlpha: 0, y: 30 }, 
      { autoAlpha: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  },
  invalidateOnRefresh: true,
});

// 初期状態を透明にする
gsap.set(".c-cover__img--parrent03", { autoAlpha: 0 });

// 【既存の ScrollTrigger】（ピン留めの設定）
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent03",
  start: "top 80", // ピン留めの開始位置
  endTrigger: ".c-cover__img--child03",
  end: "top+=-280px",
  pin: true,
  pinSpacing: false,
  // markers: true,
});

// 【フェードイン用の ScrollTrigger】
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent03",
  start: "top+=100px bottom",
  once: true,
  onEnter: () => {
    gsap.fromTo(".c-cover__img--parrent03", 
      { autoAlpha: 0, y: 30 }, 
      { autoAlpha: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  },
  invalidateOnRefresh: true,
});

// 初期状態を透明にする
gsap.set(".c-cover__img--parrent04", { autoAlpha: 0 });

// 【既存の ScrollTrigger】（ピン留めの設定）
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent04",
  start: "top 80", // ピン留めの開始位置
  endTrigger: ".c-cover__img--child04",
  end: "top+=-280px",
  pin: true,
  pinSpacing: false,
  // markers: true,
});

// 【フェードイン用の ScrollTrigger】
ScrollTrigger.create({
  trigger: ".c-cover__img--parrent04",
  start: "top+=100px bottom",
  once: true,
  onEnter: () => {
    gsap.fromTo(".c-cover__img--parrent04", 
      { autoAlpha: 0, y: 30 }, 
      { autoAlpha: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  },
  invalidateOnRefresh: true,
});

const viewportHeight = window.innerHeight;
gsap.to(".c-fix__title--wrap.-cover", {
  'clip-path': `inset(0 0 100% 0)`, 
  ease: 'none',
  scrollTrigger: {
    trigger: ".c-fix__lead",
    // start: "top bottom",
    start: `top ${viewportHeight}px`,
    end: "top top",
    scrub: true,
    // markers: true,
  }
});


function isMobile() {
  return window.innerWidth <= 780;
}

// アニメーション用（load・scrollは実行する）
$(window).on("load scroll", function() {
  if (!window.requestAnimationFrame) {
    checkAnimation();
  } else {
    requestAnimationFrame(checkAnimation);
  }
});

// resize の負荷を減らすための debounce（スマホでは実行しない）
var resizeTimer;
$(window).on("resize", function() {
  if (isMobile()) return; // スマホ時はresizeを実行しない

  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    requestAnimationFrame(checkAnimation);
  }, 200);
});

function checkAnimation() {
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();

  $(".animation").each(function() {
    var $this = $(this);
    if ($this.hasClass("active")) return;

    var position = $this.offset().top;
    if (scroll > position - windowHeight + 100) {
      $this.addClass("active");
    }
  });
}

// **ページ読み込み時に初回実行**
$(document).ready(function() {
  requestAnimationFrame(checkAnimation);
});



$(window).on("load", function() {

  /* -------------------------------------------------------------------
	分岐 780以下
	------------------------------------------------------------------- */
  
	var w = $(window).width();
  var x = 781;
  if(w <= x){
    //以下

    $(document).on("ophideComplete", function() {
      if ($('.c-header__img').length && !$('.c-header__img').hasClass('slick-initialized')) {
    
        $('.c-header__img').slick({
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 2000,
          dots: false,
          arrows: false,
          fade: true,
        });
      }
    });
    
  }else{
    //以上
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 200); // 200ms の間リサイズが行われなければ `refresh()` を実行
    });
  }
});

// function setFullHeight() {
//   if (window.innerWidth <= 781) {
//     let windowHeight = window.innerHeight + "px";

//     document.querySelectorAll(".c-header, .c-header__img img, .c-fix").forEach(el => {
//       el.style.height = windowHeight;
//     });
//   } else {
//     // 画面幅が 782px 以上のときは height をリセット
//     document.querySelectorAll(".c-header, .c-header__img img, .c-fix").forEach(el => {
//       el.style.height = "";
//     });
//   }
// }

// 初回実行
// setFullHeight();

// リサイズ時に高さを再設定
// window.addEventListener("resize", () => {
//   setTimeout(setFullHeight, 300); // 300ms の遅延で負荷軽減
// });

// $(window).on("load", function() {
//   var isRefreshed = false;

//   function refreshScrollTrigger() {
//     if (window.innerWidth > 780) {
//       ScrollTrigger.refresh();
//     } else if (!isRefreshed) {
//       ScrollTrigger.refresh();
//       isRefreshed = true; // 780px以下では1回だけ実行
//     }
//   }
//   setTimeout(refreshScrollTrigger, 6000); // 既存の6000ms後のリフレッシュ処理
// });

// 既存の resizeTimer を利用して修正
// window.addEventListener("resize", () => {
//   clearTimeout(resizeTimer);
//   resizeTimer = setTimeout(() => {
//     if (window.innerWidth > 780) {
//       ScrollTrigger.refresh();
//     }
//   }, 200); // 200ms後に実行（780px以下では実行しない）
// });


